/*! © 2026 AirX (airx.art). All rights reserved. Unauthorized copying, reproduction, or redistribution of this code is prohibited. Report infringement: info@airx.art */

(function () {
  'use strict';

  if (customElements.get('canvas-viewer-3d')) return;

  const SIZE_RE = /(\d+(?:\.\d+)?)L"x(\d+(?:\.\d+)?)H"/;
  const UNITS_PER_INCH = 0.075;
  const EDGE_FRACTION = 0.06;
  const EDGE_LONG = 256;
  const EDGE_SHORT = 32;
  const EDGE_DARKEN = 'rgb(209, 209, 209)';

  function paintWood(ctx, x, y, w, h) {
    const vertical = h > w;
    const g = vertical
      ? ctx.createLinearGradient(x, 0, x + w, 0)
      : ctx.createLinearGradient(0, y, 0, y + h);
    g.addColorStop(0, '#e6cba0');
    g.addColorStop(0.5, '#d6b586');
    g.addColorStop(1, '#c5a170');
    ctx.fillStyle = g;
    ctx.fillRect(x, y, w, h);
    ctx.save();
    ctx.beginPath();
    ctx.rect(x, y, w, h);
    ctx.clip();
    ctx.globalAlpha = 0.12;
    ctx.strokeStyle = '#96733f';
    ctx.lineWidth = 1;
    const len = vertical ? h : w;
    const across = vertical ? w : h;
    for (let i = 0; i < 6; i++) {
      const o = ((i + 0.7) / 6.4) * across;
      const wob = across * 0.16;
      ctx.beginPath();
      if (vertical) {
        ctx.moveTo(x + o, y);
        ctx.quadraticCurveTo(x + o + wob * Math.sin(i * 2.1), y + len * 0.5, x + o, y + len);
      } else {
        ctx.moveTo(x, y + o);
        ctx.quadraticCurveTo(x + len * 0.5, y + o + wob * Math.sin(i * 2.1), x + len, y + o);
      }
      ctx.stroke();
    }
    ctx.restore();

    ctx.save();
    ctx.globalAlpha = 0.14;
    ctx.fillStyle = '#6d4f28';
    if (vertical) {
      ctx.fillRect(x, y, 1.5, h);
      ctx.fillRect(x + w - 1.5, y, 1.5, h);
    } else {
      ctx.fillRect(x, y, w, 1.5);
      ctx.fillRect(x, y + h - 1.5, w, 1.5);
    }
    ctx.restore();
  }

  function drawBackTexture(wIn, hIn) {
    const long = Math.max(wIn, hIn);
    const ppi = 760 / long;
    const W = Math.max(64, Math.round(wIn * ppi));
    const H = Math.max(64, Math.round(hIn * ppi));
    const canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;

    const WRAP = 0.7 * ppi;
    const BAR = 1.4 * ppi;
    const BRACE = 1.1 * ppi;

    ctx.fillStyle = '#f6f3ec';
    ctx.fillRect(0, 0, W, H);
    ctx.globalAlpha = 0.05;
    ctx.strokeStyle = '#b9b2a2';
    ctx.lineWidth = 1;
    for (let yy = 0; yy < H; yy += 4) {
      ctx.beginPath();
      ctx.moveTo(0, yy);
      ctx.lineTo(W, yy);
      ctx.stroke();
    }
    ctx.globalAlpha = 1;
    const sheen = ctx.createRadialGradient(W / 2, H / 2, 10, W / 2, H / 2, Math.max(W, H) / 1.4);
    sheen.addColorStop(0, 'rgba(255,255,255,0.35)');
    sheen.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = sheen;
    ctx.fillRect(0, 0, W, H);

    paintWood(ctx, WRAP, WRAP, W - 2 * WRAP, BAR - WRAP);
    paintWood(ctx, WRAP, H - BAR, W - 2 * WRAP, BAR - WRAP);
    paintWood(ctx, WRAP, WRAP, BAR - WRAP, H - 2 * WRAP);
    paintWood(ctx, W - BAR, WRAP, BAR - WRAP, H - 2 * WRAP);

    ctx.save();
    ctx.strokeStyle = 'rgba(60,50,35,0.16)';
    ctx.lineWidth = 5;
    ctx.strokeRect(BAR + 2.5, BAR + 2.5, W - 2 * BAR - 5, H - 2 * BAR - 5);
    ctx.restore();

    const braces = [];
    const landscape = wIn >= hIn;
    if (long > 40) {

      if (landscape) {
        braces.push({ x: W / 3 - BRACE / 2, y: BAR, w: BRACE, h: H - 2 * BAR });
        braces.push({ x: (2 * W) / 3 - BRACE / 2, y: BAR, w: BRACE, h: H - 2 * BAR });
        braces.push({ x: W / 3 + BRACE / 2, y: H / 2 - BRACE / 2, w: W / 3 - BRACE, h: BRACE });
      } else {
        braces.push({ x: BAR, y: H / 3 - BRACE / 2, w: W - 2 * BAR, h: BRACE });
        braces.push({ x: BAR, y: (2 * H) / 3 - BRACE / 2, w: W - 2 * BAR, h: BRACE });
        braces.push({ x: W / 2 - BRACE / 2, y: H / 3 + BRACE / 2, w: BRACE, h: H / 3 - BRACE });
      }
    } else if (long > 20) {
      if (landscape) braces.push({ x: W / 2 - BRACE / 2, y: BAR, w: BRACE, h: H - 2 * BAR });
      else braces.push({ x: BAR, y: H / 2 - BRACE / 2, w: W - 2 * BAR, h: BRACE });
    }
    braces.forEach((b) => {
      ctx.save();
      ctx.fillStyle = 'rgba(60,50,35,0.13)';
      ctx.fillRect(b.x + 3, b.y + 3, b.w, b.h);
      ctx.restore();
      paintWood(ctx, b.x, b.y, b.w, b.h);
    });

    ctx.fillStyle = '#fbf8f2';
    ctx.fillRect(0, 0, W, WRAP);
    ctx.fillRect(0, H - WRAP, W, WRAP);
    ctx.fillRect(0, 0, WRAP, H);
    ctx.fillRect(W - WRAP, 0, WRAP, H);
    ctx.strokeStyle = 'rgba(0,0,0,0.10)';
    ctx.lineWidth = 1;
    ctx.strokeRect(WRAP, WRAP, W - 2 * WRAP, H - 2 * WRAP);

    ctx.fillStyle = 'rgba(88,88,92,0.6)';
    const stapleGap = 2.4 * ppi;
    const sLen = 0.3 * ppi;
    for (let xx = WRAP + stapleGap / 2; xx < W - WRAP; xx += stapleGap) {
      ctx.fillRect(xx - 1, WRAP - sLen / 2, 2, sLen);
      ctx.fillRect(xx - 1, H - WRAP - sLen / 2, 2, sLen);
    }
    for (let yy = WRAP + stapleGap / 2; yy < H - WRAP; yy += stapleGap) {
      ctx.fillRect(WRAP - sLen / 2, yy - 1, sLen, 2);
      ctx.fillRect(W - WRAP - sLen / 2, yy - 1, sLen, 2);
    }

    ctx.strokeStyle = 'rgba(0,0,0,0.09)';
    ctx.lineWidth = 2;
    const f = WRAP * 2.2;
    [[0, 0, f, f], [W, 0, W - f, f], [0, H, f, H - f], [W, H, W - f, H - f]].forEach((c) => {
      ctx.beginPath();
      ctx.moveTo(c[0], c[1]);
      ctx.lineTo(c[2], c[3]);
      ctx.stroke();
    });

    return canvas;
  }

  function drawEdgeStrip(img, side) {
    const iw = img && (img.naturalWidth || img.width);
    const ih = img && (img.naturalHeight || img.height);
    if (!iw || !ih) return null;
    const vertical = side === 'left' || side === 'right';
    const canvas = document.createElement('canvas');
    canvas.width = vertical ? EDGE_SHORT : EDGE_LONG;
    canvas.height = vertical ? EDGE_LONG : EDGE_SHORT;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    try {
      let strip;
      if (vertical) {
        strip = Math.max(2, Math.round(iw * EDGE_FRACTION));
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);
        if (side === 'right') {
          ctx.drawImage(img, iw - strip, 0, strip, ih, 0, 0, canvas.width, canvas.height);
        } else {
          ctx.drawImage(img, 0, 0, strip, ih, 0, 0, canvas.width, canvas.height);
        }
      } else {
        strip = Math.max(2, Math.round(ih * EDGE_FRACTION));
        ctx.translate(0, canvas.height);
        ctx.scale(1, -1);
        if (side === 'top') {
          ctx.drawImage(img, 0, 0, iw, strip, 0, 0, canvas.width, canvas.height);
        } else {
          ctx.drawImage(img, 0, ih - strip, iw, strip, 0, 0, canvas.width, canvas.height);
        }
      }
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.globalCompositeOperation = 'multiply';
      ctx.fillStyle = EDGE_DARKEN;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    } catch (e) {
      return null;
    }
    return canvas;
  }

  const reducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const motionOn = () =>
    window.gsap && document.documentElement.classList.contains('motion');

  function parseSize(value) {
    const m = String(value || '').match(SIZE_RE);
    if (m) return { w: parseFloat(m[1]), h: parseFloat(m[2]) };

    const g = String(value || '').match(/(\d+(?:\.\d+)?)\s*["″]?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (g) return { w: parseFloat(g[1]), h: parseFloat(g[2]) };
    return null;
  }

  function parseDepth(value) {
    const v = String(value || '');
    if (v.indexOf('3/4') !== -1) return 0.75;
    if (v.indexOf('1 1/2') !== -1) return 1.5;
    return 1.5;
  }

  function cssColor(name, fallback) {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }

  class CanvasViewer3D extends HTMLElement {
    connectedCallback() {
      this.active = false;
      this.ready = false;
      this.failed = false;
      this.dragging = false;
      this.yaw = 0.21;
      this.pitch = 0;
      this.targetYaw = 0.21;
      this.targetPitch = 0;
      this.lastInteraction = 0;
      this.clockStart = performance.now();

      const size = parseSize(this.dataset.initialSize) || { w: 24, h: 30 };
      this.dims = { w: size.w, h: size.h, d: parseDepth(this.dataset.initialDepth) };

      if (window.AirX) {
        this.onVariantChange = (e) => {
          const d = e.detail || {};
          if (!d.variant || !d.variant.options) return;
          let size = null;
          let depth = null;
          d.variant.options.forEach((opt) => {
            if (!size && SIZE_RE.test(opt)) size = parseSize(opt);
            if (/inch/i.test(opt)) depth = parseDepth(opt);
          });
          this.setDimensions(
            size ? size.w : this.dims.w,
            size ? size.h : this.dims.h,
            depth == null ? this.dims.d : depth,
            !d.initial
          );
        };
        window.AirX.on('variant:change', this.onVariantChange);
      }

      this.onVisibility = () => {
        if (document.hidden) this.stopLoop();
        else if (this.active) this.startLoop();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    disconnectedCallback() {
      if (window.AirX && this.onVariantChange) window.AirX.off('variant:change', this.onVariantChange);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.dispose();
    }

    preload() {
      if (this.modulePromise || this.failed) return;
      this.modulePromise = import(this.dataset.threeSrc).catch(() => {
        this.fail();
        return null;
      });
    }

    async activate() {
      if (this.failed) return;
      this.active = true;
      if (!this.ready) {
        if (this.building) return;
        this.building = true;
        await this.build();
        this.building = false;
      }

      if (!this.active || !this.isConnected) return;
      if (this.ready) {
        this.resize();
        this.startLoop();
      }
    }

    sleep() {
      this.active = false;
      this.stopLoop();
    }

    fail() {
      if (this.failed) return;
      this.failed = true;
      this.hidden = true;
      this.dispatchEvent(new CustomEvent('canvas-viewer:unsupported', { bubbles: true }));
    }

    async build() {

      try {
        const probe = document.createElement('canvas');
        const gl = probe.getContext('webgl2') || probe.getContext('webgl');
        if (!gl) return this.fail();
      } catch (err) {
        return this.fail();
      }

      this.preload();
      const THREE = await this.modulePromise;

      if (!THREE || this.failed || !this.isConnected) return;
      this.THREE = THREE;

      try {
        this.renderer = new THREE.WebGLRenderer({
          antialias: true,
          alpha: true,
          powerPreference: 'low-power',
        });
      } catch (err) {
        return this.fail();
      }

      const renderer = this.renderer;
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.domElement.className = 'canvas-viewer-3d__canvas';
      this.prepend(renderer.domElement);

      this.scene = new THREE.Scene();
      this.camera = new THREE.PerspectiveCamera(30, 1, 0.1, 60);
      this.camera.position.set(0, 0.1, 8.2);
      this.camera.lookAt(0, 0, 0);

      const wall = new THREE.Mesh(
        new THREE.PlaneGeometry(40, 26),
        new THREE.MeshStandardMaterial({
          color: new THREE.Color(cssColor('--color-bg-secondary', '#F1F4EC')),
          roughness: 1,
        })
      );
      wall.position.z = -0.9;
      this.scene.add(wall);

      this.scene.add(new THREE.AmbientLight(0xffffff, 1.5));
      const key = new THREE.DirectionalLight(0xfff6ea, 1.9);
      key.position.set(2.4, 3.2, 4.2);
      this.scene.add(key);
      const fill = new THREE.DirectionalLight(0xe8eef6, 0.7);
      fill.position.set(-3, -1, 3);
      this.scene.add(fill);

      this.shadow = new THREE.Mesh(
        new THREE.PlaneGeometry(1, 1),
        new THREE.MeshBasicMaterial({
          map: this.makeShadowTexture(THREE),
          transparent: true,
          opacity: 0.34,
          depthWrite: false,
        })
      );
      this.shadow.position.set(0.06, -0.1, -0.88);
      this.scene.add(this.shadow);

      this.rig = new THREE.Group();
      this.scene.add(this.rig);

      await this.buildCanvasMesh();

      if (this.failed || !this.renderer || !this.isConnected) return;

      this.bindPointer();
      this.observeResize();

      this.ready = true;
      this.applyDims(false);
    }

    makeShadowTexture(THREE) {
      const c = document.createElement('canvas');
      c.width = 128;
      c.height = 128;
      const ctx = c.getContext('2d');
      const g = ctx.createRadialGradient(64, 64, 8, 64, 64, 64);
      g.addColorStop(0, 'rgba(20, 20, 15, 0.85)');
      g.addColorStop(0.55, 'rgba(20, 20, 15, 0.35)');
      g.addColorStop(1, 'rgba(20, 20, 15, 0)');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, 128, 128);
      return new THREE.CanvasTexture(c);
    }

    loadTexture(url) {
      const THREE = this.THREE;
      return new Promise((resolve, reject) => {
        const loader = new THREE.TextureLoader();
        loader.setCrossOrigin('anonymous');
        loader.load(url, resolve, undefined, reject);
      });
    }

    resolveArtworkUrl() {
      const raw = this.dataset.texture || '';
      const file = raw.split('?')[0].split('/').pop() || '';
      const m = file.match(/^(P\d+)/);
      if (m) {
        const mini = window.AIRX_MINI_ART;
        const map = window.DYW_ART_MAP;
        let bare = null;
        if (mini && mini[m[1]]) bare = mini[m[1]];
        else if (map && map.base && map.art && map.art[m[1]]) bare = map.base + map.art[m[1]];
        if (bare) {
          if (!/[?&]width=/.test(bare)) {
            bare += (bare.indexOf('?') > -1 ? '&' : '?') + 'width=1024';
          }
          return bare;
        }
      }
      return raw;
    }

    async buildCanvasMesh() {
      const THREE = this.THREE;
      let texture;
      const artUrl = this.resolveArtworkUrl();
      try {
        texture = await this.loadTexture(artUrl);
      } catch (err) {
        if (artUrl !== this.dataset.texture) {
          try {
            texture = await this.loadTexture(this.dataset.texture);
          } catch (err2) {
            return this.fail();
          }
        } else {
          return this.fail();
        }
      }
      if (this.failed || !this.renderer) return;

      if (THREE.SRGBColorSpace) texture.colorSpace = THREE.SRGBColorSpace;
      texture.anisotropy = Math.min(4, this.renderer.capabilities.getMaxAnisotropy());
      this.texture = texture;

      const mat = (map) =>
        new THREE.MeshStandardMaterial({ map, roughness: 0.86, metalness: 0 });

      const img = texture.image;
      const beige = () => new THREE.MeshStandardMaterial({ color: 0xf1ece1, roughness: 1 });
      const sideMat = (side) => {
        const canvas = drawEdgeStrip(img, side);
        if (!canvas) return beige();
        const tex = new THREE.CanvasTexture(canvas);
        if (THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
        return mat(tex);
      };

      this.mesh = new THREE.Mesh(new THREE.BoxGeometry(1, 1, 1), [
        sideMat('right'),
        sideMat('left'),
        sideMat('top'),
        sideMat('bottom'),
        mat(texture),
        beige(),
      ]);
      this.rig.add(this.mesh);
      this.refreshBackTexture();

      if (this.customText) this.applyCustomText();
    }

    setCustomText(text, position) {
      const t = String(text == null ? '' : text).trim().slice(0, 80);
      this.customText = t ? { text: t, position: String(position || 'Bottom Right') } : null;
      if (this.ready) this.applyCustomText();
    }

    applyCustomText() {
      if (!this.mesh || !this.texture) return;
      const THREE = this.THREE;
      const front = this.mesh.material[4];

      if (!this.customText) {

        if (front.map && front.map !== this.texture) front.map.dispose();
        front.map = this.texture;
        front.needsUpdate = true;
        return;
      }

      const img = this.texture.image;
      const iw = img && (img.naturalWidth || img.width);
      const ih = img && (img.naturalHeight || img.height);
      if (!iw || !ih) return;

      const seq = (this._textSeq = (this._textSeq || 0) + 1);
      const draw = () => {

        if (seq !== this._textSeq || !this.renderer || !this.mesh || !this.customText) return;
        const W = Math.min(1600, iw);
        const H = Math.round(ih * (W / iw));
        const c = document.createElement('canvas');
        c.width = W;
        c.height = H;
        const ctx = c.getContext('2d');
        if (!ctx) return;
        try {
          ctx.drawImage(img, 0, 0, W, H);
        } catch (err) {
          return;
        }

        const value = this.customText.text;
        const crowding = Math.min(1, 16 / Math.max(value.length, 16));
        const px = Math.max(W * 0.03, Math.min(W * 0.085, W * 0.055 * (0.6 + 0.4 * crowding * 2)));
        ctx.font = '600 ' + Math.round(px) + "px 'Caveat', 'Brush Script MT', cursive";
        ctx.fillStyle = 'rgba(255,255,255,0.95)';
        ctx.shadowColor = 'rgba(0,0,0,0.5)';
        ctx.shadowBlur = px * 0.14;
        ctx.shadowOffsetY = Math.max(1, px * 0.05);
        ctx.textBaseline = 'alphabetic';
        const pad = W * 0.04;
        const pos = this.customText.position;
        let x;
        if (pos === 'Bottom Left') { ctx.textAlign = 'left'; x = pad; }
        else if (pos === 'Bottom Middle') { ctx.textAlign = 'center'; x = W / 2; }
        else { ctx.textAlign = 'right'; x = W - pad; }
        ctx.fillText(value, x, H - pad, W * 0.72);

        const tex = new THREE.CanvasTexture(c);
        if (THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
        tex.anisotropy = Math.min(4, this.renderer.capabilities.getMaxAnisotropy());
        if (front.map && front.map !== this.texture) front.map.dispose();
        front.map = tex;
        front.needsUpdate = true;
      };

      if (document.fonts && document.fonts.load) {
        document.fonts.load("600 32px 'Caveat'").then(draw, draw);
      } else {
        draw();
      }
    }

    refreshBackTexture() {
      if (!this.mesh || !this.dims) return;
      const key = Math.round(this.dims.w) + 'x' + Math.round(this.dims.h);
      if (this.backKey === key) return;
      this.backKey = key;
      const canvas = drawBackTexture(this.dims.w, this.dims.h);
      if (!canvas) return;
      const THREE = this.THREE;
      const tex = new THREE.CanvasTexture(canvas);
      if (THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
      const m = this.mesh.material[5];
      if (m.map) m.map.dispose();
      m.map = tex;
      m.color.setHex(0xffffff);
      m.needsUpdate = true;
    }

    setDimensions(w, h, d, animate) {
      this.dims = { w, h, d };
      this.updateDimsLabel();
      if (this.ready) this.applyDims(animate);
    }

    fitCamera(animate) {
      if (!this.camera || !this.dims) return;
      const k = UNITS_PER_INCH;
      const w = Math.max(0.4, this.dims.w * k);
      const h = Math.max(0.4, this.dims.h * k);
      const d = Math.max(0.05, this.dims.d * k);
      const r = 0.5 * Math.sqrt(w * w + h * h + d * d);
      const vHalf = ((this.camera.fov * Math.PI) / 180) / 2;
      const hHalf = Math.atan(Math.tan(vHalf) * Math.max(0.5, this.camera.aspect));
      const dist = Math.max(6.0, (r * 1.22) / Math.sin(Math.min(vHalf, hHalf)));
      if (animate && motionOn()) {
        window.gsap.to(this.camera.position, { z: dist, duration: 0.6, ease: 'expo.out' });
      } else {
        this.camera.position.z = dist;
      }
    }

    applyDims(animate) {
      if (!this.mesh) return;
      const k = UNITS_PER_INCH;
      const target = {
        x: Math.max(0.4, this.dims.w * k),
        y: Math.max(0.4, this.dims.h * k),
        z: Math.max(0.05, this.dims.d * k),
      };

      this.refreshBackTexture();
      this.fitCamera(animate);

      const shadowTarget = { x: target.x * 1.5, y: target.y * 1.5 };

      if (animate && motionOn()) {
        window.gsap.to(this.mesh.scale, {
          x: target.x,
          y: target.y,
          z: target.z,
          duration: 0.6,
          ease: 'expo.out',
        });
        window.gsap.to(this.shadow.scale, {
          x: shadowTarget.x,
          y: shadowTarget.y,
          duration: 0.6,
          ease: 'expo.out',
        });
      } else {
        this.mesh.scale.set(target.x, target.y, target.z);
        this.shadow.scale.set(shadowTarget.x, shadowTarget.y, 1);
      }
      this.updateDimsLabel();
    }

    updateDimsLabel() {
      const label = this.querySelector('[data-viewer-dims]');
      const template = this.dataset.dimsTemplate;
      if (!label || !template) return;
      label.textContent = template
        .replace('[w]', this.dims.w)
        .replace('[h]', this.dims.h)
        .replace('[d]', this.dims.d);
    }

    bindPointer() {
      const el = this.renderer.domElement;
      el.addEventListener('pointerdown', (e) => {
        this.dragging = true;
        this.lastX = e.clientX;
        this.lastY = e.clientY;
        this.lastInteraction = performance.now();
        el.setPointerCapture(e.pointerId);
        this.classList.add('is-dragging');
      });
      el.addEventListener('pointermove', (e) => {
        if (!this.dragging) return;
        const dx = e.clientX - this.lastX;
        const dy = e.clientY - this.lastY;
        this.lastX = e.clientX;
        this.lastY = e.clientY;

        this.targetYaw += dx * 0.006;

        this.targetPitch = Math.max(-0.26, Math.min(0.26, this.targetPitch + dy * 0.004));
        this.lastInteraction = performance.now();
      });
      const release = () => {
        this.dragging = false;
        this.lastInteraction = performance.now();
        this.classList.remove('is-dragging');
      };
      el.addEventListener('pointerup', release);
      el.addEventListener('pointercancel', release);
    }

    observeResize() {
      if (!('ResizeObserver' in window)) return this.resize();
      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(this);
    }

    resize() {
      if (!this.renderer) return;

      const w = this.clientWidth;
      const h = this.clientHeight;
      if (!w || !h) return;
      this.renderer.setSize(w, h, false);
      this.camera.aspect = w / h;
      this.camera.updateProjectionMatrix();
      this.fitCamera(false);
      this.needsRender = true;
    }

    startLoop() {
      if (this.raf || !this.ready) return;
      const tick = () => {
        this.raf = requestAnimationFrame(tick);
        this.step();
      };
      this.raf = requestAnimationFrame(tick);
    }

    stopLoop() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    step() {
      if (!this.rig) return;

      if (
        !this.dragging &&
        !reducedMotion() &&
        performance.now() - this.lastInteraction > 2500
      ) {
        if (!this.idleAnchor) {
          this.idleAnchor = { yaw: this.targetYaw, pitch: this.targetPitch };
        }
        const t = (performance.now() - this.clockStart) / 1000;
        this.targetYaw = this.idleAnchor.yaw + Math.sin(t * 0.35) * 0.13;
        this.targetPitch = this.idleAnchor.pitch * 0.4 + Math.sin(t * 0.22) * 0.03;
      } else {
        this.idleAnchor = null;
      }

      this.yaw += (this.targetYaw - this.yaw) * 0.08;
      this.pitch += (this.targetPitch - this.pitch) * 0.08;
      this.rig.rotation.y = this.yaw;
      this.rig.rotation.x = this.pitch;

      if (this.shadow) this.shadow.position.x = 0.06 + this.yaw * 0.18;

      this.renderer.render(this.scene, this.camera);
    }

    dispose() {
      this.stopLoop();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.scene) {
        this.scene.traverse((obj) => {
          if (obj.geometry) obj.geometry.dispose();
          if (obj.material) {
            const mats = Array.isArray(obj.material) ? obj.material : [obj.material];
            mats.forEach((m) => {
              if (m.map) m.map.dispose();
              m.dispose();
            });
          }
        });
      }
      if (this.renderer) {
        this.renderer.dispose();
        if (this.renderer.domElement && this.renderer.domElement.parentNode) {
          this.renderer.domElement.parentNode.removeChild(this.renderer.domElement);
        }
      }
      this.renderer = null;
      this.scene = null;
      this.mesh = null;
      this.ready = false;
    }
  }

  customElements.define('canvas-viewer-3d', CanvasViewer3D);
})();
